import Spinner from './Spinner';

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/Spinner/index.js